<div class="price-and-actions-block" [class.discount-block]="order?.discounts?.length > 0"
  [class.sticky-to-top]="stickyToTop">
  <div class="price-block">
    <div class="price">
      <span>@if(order?.totalWithTax | formatPrice | async; as totalPrice){
        {{ totalPrice }}
        } @else { - }</span>
    </div>
    @if (order?.discounts?.length == 0) {
    <div class="including-vat-line">
      <span> Incl. VAT </span>
    </div>
    } @if (order?.discounts?.length > 0) {
    <div class="price-before-discount-line">
      <span>@if((order?.totalWithTax-order?.discounts[0]?.amountWithTax) |
        formatPrice | async; as totalPrice){
        {{ totalPrice }}
        } @else { - }</span>
    </div>
    }
  </div>

  @if (benefitsEnabled) {
  <div>
    <app-item-benefits [classess]="'mb-unset'" [singleBenefitStyles]="true" [benefits]="cartBenefits">
    </app-item-benefits>
  </div>
  }

  <app-item-payment-totals [order]="order"></app-item-payment-totals>

  @if((!order?.discounts || order?.discounts?.length == 0) &&
  !inOrderConfirmation){
  <div class="mb-20-px">
    <app-coupon-code-input></app-coupon-code-input>
  </div>
  } @if(inCart){
  <button [routerLink]="['/checkout']" [disabled]="loading || !order" pButton pRipple
    class="c-button green w-100 mb-24-px large">
    @if(loading){
    <p-progressSpinner styleClass="c-loader light btn-size" strokeWidth="2" animationDuration=".5s"></p-progressSpinner>
    } @else {
    <span>Proceed to checkout</span>
    <img class="ml-8-px" src="./../../../../assets/images/icons/arrow-right-white.svg" alt="proceed-to-checkout" />
    }
  </button>
  } @if(inCheckout){

  <button (click)="checkValidation() && showApproveDialog()" [disabled]="
      loading ||
      !order" pButton pRipple class="c-button green w-100 mb-24-px large">
    @if(loading){
    <p-progressSpinner styleClass="c-loader light btn-size" strokeWidth="2" animationDuration=".5s"></p-progressSpinner>
    } @else {
    <span>Proceed to payment</span>
    <img class="ml-8-px" src="./../../../../assets/images/icons/arrow-right-white.svg" alt="proceed-to-checkout" />
    }
  </button>
  } @if(inOrderConfirmation){
  <!--
        <button pButton pRippble class="c-button light w-100">Print order confirmation</button>
         -->
  @if(!userLoggedIn){
  <button (click)="register()" pButton pRippble class="c-button light w-100 mt-16-px">1-click create account</button>
  <div class="mt-16-px">
    <app-account-benefits></app-account-benefits>
  </div>

  }


  } @if(!inOrderConfirmation){
  <div>
    <app-payment-methods-logo-list></app-payment-methods-logo-list>
  </div>
  }
</div>
